import api from '@/lib/api'

export interface MenuItemActions {
  create?: string
  update?: string
  delete?: string
  [key: string]: string | undefined
}

export interface MenuItem {
  key: string
  label: string
  icon: string
  permission?: string | null
  /** Action-level permission slugs for CRUD button gating */
  actions?: MenuItemActions
  children?: MenuItem[]
}

export const getMenu = () =>
  api
    .get<{ success: true; data: MenuItem[] }>('/menu')
    .then((r) => r.data.data ?? [])
